import InfoIcon from "@mui/icons-material/Info";
import { styled } from "@mui/material";
import { colors } from "theme/defaultStyle";

const StyledInfoIcon = styled(InfoIcon)({
  color: `${colors.blue01}`,
});

export default StyledInfoIcon;
